var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card-group',[_c('b-card',{attrs:{"header":_vm.title,"header-bg-variant":"dark","header-text-variant":"white h4"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }